import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MotivoRechazo extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'rechazo-motivo/one', saveUrl: 'rechazo-motivo/save', backUrl: '/Catalogo/MotivosRechazo' },
      new Form([
        Form.Field('text', 'rechazo_motivo', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'rechazo_motivo_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Motivo De Rechazo'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MotivoRechazo)
